{
  "title": "Roster list",
  "displayRule": "Ally rows show nickname, game ID, and marching time. Enemy rows show nickname and marching time. The game ID is visible on this screen only. It never goes out to alliance member screens.",
  "marchingOnlyHere": "This roster list is the only place marching time can be changed. The rally editor cannot change it.",
  "nextSeedAlly": "Add your allies first. Enter game ID, nickname, and marching",
  "nextGoAttack": "Build the main on the ATTACK tab",
  "nextOpsInAttack": "The running ops is on the ATTACK tab",
  "operationDispatched": "A confirmed ops is running. Marching changed here does not move that ops. It applies when you retime.",
  "operationAssembling": "The ops is still assembling. Marching changed here applies to it right away.",
  "allyTitle": "Ally",
  "allyWhy": "The ally roster list is the whitelist itself. A game ID that is not here cannot get in, even with the join code.",
  "allyGameId": "Game ID",
  "allyGameIdHint": "Digits only (e.g. 131952426)",
  "allyNickname": "Nickname",
  "allyMarching": "Marching time",
  "allyAdd": "Add",
  "allyEmpty": "No allies added yet",
  "allyMarchingNote": "This marching time applies to the person being added. For someone already on the roster list, change it in the list below.",
  "allyNewOnly": "Adding takes new people only. Renaming and deleting happen in that person's row in the list below.",
  "allyGameIdTypo": "If a game ID went in wrong, delete that row and add the person again. A game ID cannot be changed from the row.",
  "allyAdded": "Added to the roster list: {new}",
  "enemyTitle": "Enemy",
  "enemyWhy": "Add an enemy by nickname alone, even with no marching time measured yet. That enemy's rally shows as impact unknown.",
  "enemyNickname": "Nickname",
  "enemyMarching": "Marching time (leave blank if unknown)",
  "enemyAdd": "Add",
  "enemyEmpty": "No enemies added yet",
  "enemyDuplicateNote": "Adding the same nickname again does not create a second row.",
  "enemyAdded": "Added to the enemy roster list: {new}",
  "enemyExisting": "Already on the enemy roster list: {new}. Change the marching time from the list.",
  "columnNickname": "Nickname",
  "columnMarching": "Marching",
  "needsInput": "Needs input",
  "reading": "Reading the roster list",
  "marchingPlaceholder": "4:00",
  "marchingHelp": "Save an empty field and the row goes back to “Needs input”.",
  "save": "Save",
  "cancel": "Cancel",
  "rename": "Rename",
  "renameLabel": "New name",
  "renamed": "Renamed: {old} → {new}. The marching time is unchanged.",
  "remove": "Delete",
  "removeConfirmAlly": "Deleting takes {name} off the roster list. If that person's screen is open right now, it disconnects with them. Marching {value} goes too. Press Delete again to confirm.",
  "removeConfirmAllyBlank": "Deleting takes {name} off the roster list. If that person's screen is open right now, it disconnects with them. Press Delete again to confirm.",
  "removeConfirmEnemy": "Deleting also erases the marching time recorded for {name} ({value}). This cannot be undone. Press Delete again to confirm.",
  "removeConfirmEnemyBlank": "Deleting takes {name} off the roster list. This cannot be undone. Press Delete again to confirm.",
  "removed": "Deleted: {name}",
  "marchingSaved": "Saved: {value}.",
  "marchingCleared": "Cleared. Back to Needs input.",
  "savedWhileDispatched": "The running ops is unchanged.",
  "savedWhileAssembling": "Applied to the assembling ops.",
  "clearedWhileAssembling": "With marching empty, this person's row drops out of the assembling ops.",
  "badTime": "Not a time. Write it like 4:00 or 3:59.5.",
  "needNickname": "Enter a nickname.",
  "needGameId": "Enter a game ID."
}
